export default "__VITE_ASSET__DKzfTx9w__"